<template>
    <h2>{{ headline }}</h2>
    <h5 v-if="text">{{ text }}</h5>
    <ul class="feature-card__list">
        <StoryblokComponent v-for="blok in list" :key="blok._uid" :blok="blok" />
    </ul>
</template>

<script lang="ts" setup>
import type { SbBlokData } from '@/components/StoryblokComponent.vue';

defineProps<{ headline: string; text?: string; list: SbBlokData[] }>();
</script>
